// extracted by mini-css-extract-plugin
export default {"Root":"SelectFactor_Root__-vjD1","Buttons":"SelectFactor_Buttons__rOE1H","Button":"SelectFactor_Button__NLPFp"};